<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
      </div>
      <export-components :apiFunction="downloadRequest" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true" :key="activeTab"
      :table-col-check="{isShow:true,name:'Dry-Ice1' + activeTab}" ref="wMyTable" :page="page"
      @pageChange="handlePagePagination" :isShowRowSelection="true">
      <div slot="operation" slot-scope="{text,record}">
        <el-button size="mini" v-if="activeTab === 'history'" type="success"
          @click="handleDetails(record)">查看详情</el-button>
        <el-button size="mini" v-if="activeTab === 'new'" type="primary" @click="handleArrange(record)">干冰安排</el-button>
        <el-button size="mini" v-if="activeTab === 'new' && ['SALES_ASSI_MANAGER', 'MANAGER', 'ADMIN'].includes(role)"
          type="danger" @click="handleNot(record)">取消安排</el-button>
      </div>
      <div slot="recipient" slot-scope="{record}">
        <span v-if="record.recipientName">{{record.recipientName + ',' + record.recipientPhone + ',' +
          record.recipientAddress}}</span>
      </div>
      <div slot="arrangeFlag" slot-scope="{record}">
        <div class="status-tag-container" v-if="record.status !== 'DEFEAT'">
          <el-tag v-if="record['arrangeFlag'] === 1" type="success">已安排</el-tag>
          <el-tag v-else-if="record['arrangeFlag'] === 0" type="warning">待安排</el-tag>
          <el-tag v-else type="info">未知状态</el-tag>
        </div>
        <div v-else>
          <span v-if="record['status'] === 'DEFEAT'" style="display: flex;align-items: center">
            <el-tag type="danger">
              <span>已取消</span>
            </el-tag>
            <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look" :text="record.rejectionReason"
              :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
            </w-ellipsis-and-look>
          </span>
        </div>
      </div>
      <div slot="material" slot-scope="{record,index}">
        <ex-fold-cell-too :data="materialData" :index="index"
          :record="record.materialRequestDetailDTOS"></ex-fold-cell-too>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <request-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="showDetails"
      @submit="close"></request-details>
    <arrange-dry-ice v-if="showArrange" :show-dialog="showArrange" :select-detail="arrangeDetails"
      @submit="closeArrange"></arrange-dry-ice>
    <not-arrange-mail v-if="showNotMail" select-type="dryIce" :show-dialog="showNotMail" :select-detail="notMail"
      @submit="closeNotDialog"></not-arrange-mail>
  </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldCellToo from "@/components/ExFoldCellToo.vue";
import RequestDetails from "@/components/material/Request/RequestDetails.vue";
import RequestMailDialog from "@/components/material/Request/RequestMailDialog.vue";
import {arrangeDryIce, downloadRequest, getRequestPage} from "@/api/dilivery/material/request";
import {newArrange} from "@/utils/data/tableCol/material/DryIceArrange/newArrange";
import {historyArrange} from "@/utils/data/tableCol/material/DryIceArrange/historyArrange";
import ArrangeDryIce from "@/components/material/Request/ArrangeDryIce.vue";
import NotArrangeMail from "@/components/mail/NotArrangeMail.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";

export default {
  name: "DryIceArrange",
  components: {
    ExportComponents,
    PictureLoading,
    NotArrangeMail,
    ArrangeDryIce, RequestMailDialog, RequestDetails, ExFoldCellToo, ExFoldTable, TableHeadNote},
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '待安排', name: 'new', showBadge: true },
        { label: '已安排', name: 'history', showBadge: false },
        { label: '已取消', name: 'cancel', showBadge: false },
      ],
      sendData: {
        all: { "query#materialType.EQ": "DRY_ICE" },
        new: { "query#status.EQ": "SUCCESS", "query#materialType.EQ": "DRY_ICE", "query#arrangeFlag.EQ": 0 },
        history: { "query#status.EQ": "SUCCESS", "query#materialType.EQ": "DRY_ICE", "query#arrangeFlag.EQ": 1 },
        cancel: { "query#status.EQ": "DEFEAT", "query#materialType.EQ": "DRY_ICE" },
      },
      pageTotal: { all: 0, new: 0, history: 0, cancel: 0 },
      role: '',
      activeTab: 'new',
      materialData: { name: 'materialLexiconDTO.materialName', value: 'number' },
      option: [
        { label: '送达时间(干冰)', value: 'deliveryTime' },
        { label: '处理时间', value: 'operatingTime' },
        { label: '创建时间', value: 'createTime' },
      ],
      loading: true,
      showDetailsDialog: false,
      showDetails: '',
      showArrange: false,
      arrangeDetails: true,
      showNotMail: false,
      notMail: '',
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  computed: {
    columns() {
      if (this.activeTab === 'new') {
        return JSON.parse(JSON.stringify(newArrange([] || {})))
      } else {
        return JSON.parse(JSON.stringify(historyArrange([] || {})))
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    downloadRequest,
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getRequestPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      })
    },
    closeNotDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => { this.showNotMail = false })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    handleNot(row) {
      this.notMail = row
      this.showNotMail = true
    },
    getSearch(sendData) {
      
      const keys = ['salesName']
      this.searchConditionTag.forEach(item => {
        if (this.option.map(item => item.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else if (keys.includes(item.key)) {
          sendData[item.key] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    handleDetails(row) {
      this.showDetails = row
      this.showDetailsDialog = true
    },
    handleArrange(row) {
      this.arrangeDetails = row
      this.showArrange = true
    },
    close() {
      this.$nextTick(() => { this.showDetailsDialog = false })
    },
    closeArrange(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.arrangeDetails = {}
      this.$nextTick(() => { this.showArrange = false })
    },
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
